var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 92,
    viewBox: "0 0 144 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M117.675,38.717c0-.383.064-.767.064-1.15A37.1,37.1,0,0,0,47.025,21.4,19.087,19.087,0,0,0,19.511,35.458,29.082,29.082,0,0,0,28.768,92H61.714V66.444H46.221L72,39.707,97.779,66.412H82.286V91.968h35.454a26.628,26.628,0,0,0-.064-53.251Z",
    fill: "#43425d",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.302f001a583db1dc98878a7669227852.svg";
export { ForwardRef as ReactComponent };